<!--- frmGenerarPaleDestrioVolcado  ---->
<!---
Descripción del formulario :
---------------------------
-

Eventos del componente:
-----------------------
-
-->

<template>
  <f7-page>
    <f7-navbar
      :style="appTheme"
      sliding
    >
      <div class="lefth">
        <f7-link back>
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </div>
      <f7-nav-title>
        {{ $t('production.dump.discards.title') }}
      </f7-nav-title>
    </f7-navbar>
    <PCInformacionLineaPunto
      class="navbar-azul-2"
    />
    <div class="div-rectanguloTitulo_1">
      <span class="span-titulo_1">
        {{ $t('production.dump.discards.action.titleText', { action: valorAccionFormulario }) }}
      </span>
    </div>

    <div
      class="div-informacionFormulario"
    >
      <span class="span-informacionFormulario">
        {{ $t('production.dump.discards.instructions') }}
      </span>
    </div>

    <div class="div-contenidoFrm">
      <div class="div-selectorEnvaseDelPaleDestrio">
        <!-- <UCPackagingItems
          :valor-por-defecto="articuloEnvaseDefectoFamiliaProductoVolcado"
          plantilla="P2"
          :parent-theme="appTheme"
          @envaseEstablecido="EstablecerEnvase"
        /> -->
        <UCSearchEntityERP
          :title="$t('common.package')"
          :placeholder="$t('common.package')"
          :search-text="$t('searchEntity.container.searchText')"
          :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
          :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
          :default-value="articuloEnvaseDefectoFamiliaProductoVolcado"
          :end-point-for-code-search="obtenerEnvasePorCodigo"
          :end-point-for-list="obtenerEnvases"
          :property-entity-shown-input="['Codigo', 'Nombre']"
          :property-entity-shown-list-title="['Codigo']"
          :property-entity-shown-list-subtitle="['Nombre']"
          :min-text-search="0"
          :autofocus-on-deselection="true"
          :auto-focus-on-empty-search-result="true"
          @selection="EventEnvaseSelected"
        />
      </div>

      <!-- Unidad Medida Kilo y Envase -->
      <div class="div-selectorEnvasesYKilos">
        <span
          class="span-texto-azulOscuro-16-500"
        >
          {{ $t('production.dump.discards.quantities').toUpperCase() }}
        </span>
        <UCUnitMeasureKiloAndContainer
          ref="componenteUCUnidadMedidaKiloYEnvase"
          :default-envases="1"
          :deshabilitar="articuloEnvaseSeleccionado == null"
          plantilla="P2"
          :autocalculo="true"
          :envase="articuloEnvaseSeleccionado"
          :producto="volcadoSeleccionadoLocal != null ? volcadoSeleccionadoLocal.Producto : null"
          @cantidad-envases-y-kilos-modificada="EventoCantidadKilosEnvasesMoficiada"
        />
      </div>

      <f7-row class="">
        <f7-col width="100">
          <f7-button
            v-if="cantidadProductoSeleccionada > 0"
            fill
            :disabled="validacionFormulario"
            class="btn-tamaño-3"
            @click="RegistrarDestrio()"
          >
            {{ $t('production.dump.discards.buttons.register.buttonText') }}
          </f7-button>
          <f7-button
            v-else
            fill
            :disabled="validacionFormulario"
            class="btn-tamaño-3"
            @click="RegistrarDestrio()"
          >
            {{ $t('production.dump.discards.buttons.delete.buttonText') }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import UCUnitMeasureKiloAndContainer from '@/components/common/UCUnitMeasureKiloAndContainer.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { sleep } from '@/js/utils/sleep';
import { f7 } from 'framework7-vue';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';

export default {
  name: 'FrmGenerateDumpDiscardsPallet',
  components: {
    UCUnitMeasureKiloAndContainer,
    PCInformacionLineaPunto,
    UCSearchEntityERP,
  },

  data() {
    return {
      articuloEnvaseDefectoFamiliaProductoVolcado: null, // Envase por defecto para la familia del artículo volcado al inicializar el frm
      articuloEnvaseSeleccionado: null,
      cantidadEnvasesSeleccionada: 1,
      cantidadProductoSeleccionada: 1, // TODO
      volcadoSeleccionadoLocal: null,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['volcadoSeleccionado']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    valorAccionFormulario() {
      if (this.cantidadProductoSeleccionada <= 0) {
        return this.$t('common.delete');
      }
      return this.$t('common.new');
    },
    validacionFormulario() {
      if (!(this.cantidadProductoSeleccionada < 0 || this.articuloEnvaseSeleccionado === null)) {
        return false;
      }
      return true;
    },
  },

  created() {
    this.InicializarFrm();
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.volcadoSeleccionadoLocal = this.volcadoSeleccionado;
      this.ObtenerEnvasePorDefectoProducto();
    },

    EstablecerEnvase(objEnvase) {
      Log(this, this.EstablecerEnvase.name);
      this.articuloEnvaseSeleccionado = objEnvase;
      sleep(500).then(() => {
        this.$refs.componenteUCUnidadMedidaKiloYEnvase.AutocalcularCantidadKilos();
      });
    },

    ObtenerEnvasePorDefectoProducto() {
      Log(this, this.ObtenerEnvasePorDefectoProducto.name);
      const self = this;
      PreloaderGH(true, true, this.$t('production.dump.discards.loading.preloader.text'), this.$t('common.searchCancelled'));
      if (this.volcadoSeleccionadoLocal.Producto != null && this.volcadoSeleccionadoLocal.Producto.Familia != null) {
        this.Conexion_ObtenerEnvasePorDefectoFamilia(this.volcadoSeleccionadoLocal.Producto.Familia.Id).then((objArticuloEnvase) => {
          if (objArticuloEnvase != null) {
            self.articuloEnvaseDefectoFamiliaProductoVolcado = objArticuloEnvase;
            self.EstablecerEnvase(objArticuloEnvase);
          }
        })
          .catch((mesnaje) => {
            LogError('No es posible obtener el envase por defecto para la familia del articulo');
            HiNotification.Toast(mesnaje);
            self.articuloEnvaseDefectoFamiliaProductoVolcado = null;
          }).finally(() => {
            PreloaderGH(false);
          });
      }
    },

    EventoCantidadKilosEnvasesMoficiada(objNuevasCantidades) {
      Log(this, this.EventoCantidadKilosEnvasesMoficiada.name);
      if (objNuevasCantidades) {
        this.cantidadProductoSeleccionada = objNuevasCantidades.CantidadKilosModificado;
        this.cantidadEnvasesSeleccionada = objNuevasCantidades.CantidadEnvasesModificado;
      }
    },
    VolverAtrasConRecarga() {
      f7.views.main.router.back();
      sleep(500).then(() => {
        f7.views.main.router.refreshPage();
      });
    },

    RegistrarDestrio() {
      Log(this, this.RegistrarDestrio.name);
      const self = this;
      if (self.cantidadProductoSeleccionada > 0) {
        PreloaderGH(true, false, this.$t('production.dump.discards.buttons.register.action.preloader.text'), '');
      } else {
        PreloaderGH(true, false, this.$t('production.dump.discards.buttons.delete.action.preloader.text'), '');
      }
      this.Conexion_RegistrarDestrio(
        this.volcadoSeleccionadoLocal.Id,
        this.articuloEnvaseSeleccionado.Id,
        this.cantidadEnvasesSeleccionada,
        this.cantidadProductoSeleccionada,
      ).then((objPaleDestrio) => {
        if (self.cantidadProductoSeleccionada > 0) {
          HiNotification.Toast(this.$t('production.dump.discards.buttons.register.successToastText', {
            serialNumber: objPaleDestrio.NumeroSerie,
          }));
        } else {
          HiNotification.Toast(this.$t('production.dump.discards.buttons.delete.successToastText'));
        }
        PreloaderGH(false);
        this.VolverAtrasConRecarga();
      }).catch((error) => {
        PreloaderGH(false);
        HiNotification.Toast(error);
      });
    },
    EventEnvaseSelected(obj) {
      Log(this, this.EventEnvaseSelected.name);
      this.configuracion.UbicacionDestinoPalesProduccidos = obj;
    },
    /* Envases */
    obtenerEnvasePorCodigo(params) {
      Log(this, this.obtenerEnvasePorCodigo.name);
      return ConexionTA.callObtenerArticulosDeTipoEnvasePorCodigo(params);
    },
    obtenerEnvases() {
      Log(this, this.obtenerEnvases.name);
      return ConexionTA.callObtenerArticulosDeTipoEnvase();
    },

    Conexion_ObtenerEnvasePorDefectoFamilia(idFamiliaProducto) {
      Log(this, this.Conexion_ObtenerEnvasePorDefectoFamilia.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerEnvasePorDefectoDestrioXFamilia(
          idFamiliaProducto,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            LogError('error');
          });
      });
    },

    Conexion_RegistrarDestrio(idColaVolcado, idEnvase, cantidadEnvases, cantidadProducto) {
      Log(this, this.Conexion_RegistrarDestrio.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callRegistrarDestrio(
          idColaVolcado,
          idEnvase,
          cantidadEnvases,
          cantidadProducto,
        ).then((result) => {
          if (result.Valor) {
            if (Number.parseFloat(cantidadEnvases) === 0 && Number.parseFloat(cantidadProducto) === 0) {
              resolve(result.Mensaje); // Palé eliminado, se retorna mensaje.
            } else {
              resolve(JSON.parse(result.Mensaje));
            } // Palé generado, se retorna el codigo del palé
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
            LogError('error');
          });
      });
    },
  },
};
</script>

<style scoped>
.div-contenidoFrm {
  margin-top: 10px;
  margin-left: 15px;
  margin-right: 20px;
}

.div-informacionFormulario {
  margin-top: 22px;
  margin-left: 18px;
  margin-right: 18px;
  margin-bottom: 10px;
  text-align: justify;
}

.span-informacionFormulario {
  opacity: 0, 9;
  color: var(--his-ash-gray);
  font-size: 14px;
}

.div-selectorEnvaseDelPaleDestrio {
  margin-bottom: 35px;
}

.div-selectorEnvasesYKilos {
  margin-bottom: 35px;
  margin-left: 10px;
}

.navbar-azul-2 {
  background-color: var(--his-steel-blue) !important;
}

.div-rectanguloTitulo_1 {
  height: 99px;
  background: var(--his-tierra-white);
  display: flex;
  align-items: flex-end;
  padding-left: 20px;
  padding-bottom: 6px;
  border: 1px solid var(--his-disabled);
}

.span-titulo_1 {
  width: 186, 01px;
  height: 37px;
  color: #24253d;
  font-size: 28px;
}

.span-texto-azulOscuro-16-500 {
  color: rgb(37 56 88);
  font-size: 16px;
  font-weight: 500;
}

.btn-tamaño-3 {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
